import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
  Autoplay,
  Navigation,
  A11y,
  Lazy,
  EffectFade,
  Pagination
} from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';
import 'swiper/css/a11y';

import 'swiper/css/pagination';
import 'swiper/css/thumbs';
import 'swiper/css/effect-fade';
import styled from 'styled-components';
import BlogRelatedTourCard from './BlogRelatedTourCard';
import { TourCardType } from '../../../../types/pages/landing-page';

SwiperCore.use([Autoplay, Navigation, Pagination, Lazy, A11y, EffectFade]);

interface BlogRelatedTourCardProps {
  products: TourCardType[];
}

const SwiperStyle = styled(Swiper)`
  .swiper-wrapper {
    padding-bottom: 1.5rem;
  }
`;

const BlogRelatedTourSwiper = ({ products }: BlogRelatedTourCardProps) => {
  return (
    <>
      <SwiperStyle
        slidesPerView="auto"
        spaceBetween={20}
        grabCursor
        pagination={{ dynamicBullets: true }}
        lazy={{
          loadPrevNext: false,
          checkInView: true
        }}
        breakpoints={{
          320: {
            slidesPerView: 1
          },
          340: {
            slidesPerView: 1.2,
            spaceBetween: 15
          },
          360: {
            slidesPerView: 1.2,
            spaceBetween: 15
          },
          375: {
            slidesPerView: 1.25,
            spaceBetween: 15
          },
          390: {
            slidesPerView: 1.3
          },
          425: {
            slidesPerView: 1.4
          },
          540: {
            slidesPerView: 1.5
          },
          640: {
            slidesPerView: 1.3
          },

          768: {
            slidesPerView: 1.5
          },
          840: {
            slidesPerView: 1.8
          }
        }}
      >
        {products?.slice(0, 3)?.map(
          (product: TourCardType, index: number) =>
            product?.carousel &&
            product?.carousel?.length > 0 && (
              <SwiperSlide key={index}>
                <BlogRelatedTourCard product={product} />
              </SwiperSlide>
            )
        )}
      </SwiperStyle>
    </>
  );
};

export default BlogRelatedTourSwiper;
